// extracted by mini-css-extract-plugin
export default {"previewTable":"SimpleSectionTable_previewTable__zPqKm"};